module.exports = __webpack_public_path__ + "static/media/fixed_voice_dash_flag_white.dabd2159.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_dash_flag_white.svg
// module id = 974
// module chunks = 0